import type { SpreadMode, SpreadTypeOption } from '@/types';
import { ru } from './ru';

/** Default locale strings. Replace with a locale switcher when i18n is added. */
export const t = ru;

export { ru };

export function spreadTypeDescription(
  type: SpreadTypeOption,
  mode: SpreadMode,
): string {
  if (type.id === 'classic-3' && mode === 'person-photo') {
    return t.spread.types.classic3.personPhotoDescription;
  }
  return type.description;
}

export const spreadTypes: SpreadTypeOption[] = [
  {
    id: 'auto-photo',
    name: t.spread.types.autoPhoto.name,
    description: t.spread.types.autoPhoto.description,
    modes: ['photo-reading'],
  },
  {
    id: 'classic-3',
    name: t.spread.types.classic3.name,
    description: t.spread.types.classic3.description,
    modes: ['photo-reading', 'person-photo', 'generate'],
  },
  {
    id: 'cross-4',
    name: t.spread.types.cross4.name,
    description: t.spread.types.cross4.description,
    modes: ['photo-reading', 'generate'],
  },
  {
    id: 'horseshoe',
    name: t.spread.types.horseshoe.name,
    description: t.spread.types.horseshoe.description,
    modes: ['photo-reading', 'generate'],
  },
];

export const spreadModes: { id: SpreadMode; label: string; icon: string }[] = [
  {
    id: 'photo-reading',
    label: t.spread.modes.photoReading,
    icon: String.fromCodePoint(0x1f4f1),
  },
  {
    id: 'person-photo',
    label: t.spread.modes.personPhoto,
    icon: String.fromCodePoint(0x1f52e),
  },
  {
    id: 'generate',
    label: t.spread.modes.generate,
    icon: String.fromCodePoint(0x1f3b4),
  },
];

export const homeOptions = [
  {
    icon: String.fromCodePoint(0x1f4f1),
    title: t.home.options.photoReading.title,
    description: t.home.options.photoReading.description,
    mode: 'photo-reading' as const,
  },
  {
    icon: String.fromCodePoint(0x1f52e),
    title: t.home.options.personPhoto.title,
    description: t.home.options.personPhoto.description,
    mode: 'person-photo' as const,
  },
  {
    icon: String.fromCodePoint(0x1f3b4),
    title: t.home.options.generate.title,
    description: t.home.options.generate.description,
    mode: 'generate' as const,
  },
] as const;

export const ratingOptions = [
  { v: 'up' as const, icon: String.fromCodePoint(0x1f496), label: t.result.ratings.good },
  { v: 'mid' as const, icon: String.fromCodePoint(0x1f60c), label: t.result.ratings.neutral },
  { v: 'down' as const, icon: String.fromCodePoint(0x1f62b), label: t.result.ratings.bad },
];

export function formatSpreadCompletedRu(isoOrDate: string | Date): string {
  const d = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate;
  if (Number.isNaN(d.getTime())) return '';
  const day = d.getDate();
  const month = t.dates.monthsFull[d.getMonth()];
  const year = d.getFullYear();
  const h = String(d.getHours()).padStart(2, '0');
  const m = String(d.getMinutes()).padStart(2, '0');
  return t.dates.spreadCompleted(day, month, year, h, m);
}

export function formatHistoryDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const h = String(d.getHours()).padStart(2, '0');
  const m = String(d.getMinutes()).padStart(2, '0');
  return t.dates.historyItem(d.getDate(), t.dates.monthsShort[d.getMonth()], d.getFullYear(), h, m);
}
